// extracted by mini-css-extract-plugin
module.exports = {"warning":"style_warning__1DbmY","icon":"style_icon__w8kAC","content":"style_content__ZnheC"};